import React from 'react';
const Example = () => (<section className="mb-9 card">
        <div className="card-body">
            <div className="mb-7">
                <div className="card-title">
                    <span className="text-primary font-weight-medium">11 %</span> dokončeno
                </div>
                <div className="progress progress--small">
                    <div className="progress-bar" role="progressbar" aria-valuenow={11} aria-valuemin={0} aria-valuemax={100} style={{
        width: '11%',
    }}>
                        {' '}
                    </div>
                </div>
            </div>
            <div className="border rounded mb-7 p-6">
                <p className="mb-4 text-secondary card__text-line--smaller">Následuje 5. lekce z 1. kurzu</p>
                <p className="mb-0 text-truncate-line" title="Řešení krizových situací v týmu, kde je ten svatý grál">
                    Řešení krizových situací v týmu, kde je ten svatý grál
                </p>
            </div>
            <a href="#" className="btn btn-primary btn-large btn-block">
                Pokračovat ve studiu
            </a>
            <a href="#" className="btn btn-outline-primary btn-large btn-block">
                Doporučit kolegovi
            </a>
        </div>
        <div className="card-footer bg-white">
            <p className="mb-6">
                <small className="text-secondary">
                    Program vás nezaujal? Můžete se <a href="#">odhlásit ze studia</a>
                </small>
            </p>
        </div>
    </section>);
export default Example;
